import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { trackEvent } from "@/lib/posthog";

export default function UpgradeSuccess() {
  useEffect(() => {
    trackEvent("upgrade_success_page_viewed", { plan: "pro" });
  }, []);

  return (
    <div className="min-h-screen bg-ink-950 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <CheckCircle className="w-16 h-16 text-figgy-400 mx-auto" />
        <h1 className="mt-6 font-display font-medium text-3xl text-white tracking-tight">
          You're on PRO
        </h1>
        <p className="mt-3 text-white/60 text-base">
          Your subscription is active. You now have access to all PRO features and your Figgy fee drops to 0.75% per online payment, plus standard processing fees.
        </p>
        <Link
          to="/dashboard"
          className="mt-8 inline-block bg-figgy-500 hover:bg-figgy-600 text-white font-bold text-sm py-3 px-8 rounded-2xl transition"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  );
}
